module.exports = __webpack_public_path__ + "img/nmgzzq_position_img.3b74d5f5.png";